/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Duties_InInputs */

const en_setup_duties_in = /** @type {(inputs: Setup_Duties_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duties in`)
};

/**
* | output |
* | --- |
* | "Duties in" |
*
* @param {Setup_Duties_InInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const setup_duties_in = /** @type {((inputs?: Setup_Duties_InInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Duties_InInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_setup_duties_in(inputs)
});